<template>
    <div class="block-processes-team" :style="'justify-content:'+styleJustifyContent">
        <ejs-tooltip v-for="(itemPt, indexPt) in processesTeamData" :key="indexPt" :content="itemPt.user_name"
                     ref="tooltip" :position="'TopCenter'">
            <div :class="'e-avatar e-avatar-small e-avatar-circle e-avatar-'+itemPt.type">
                {{ $getInitials(itemPt.user_name) }}
            </div>
        </ejs-tooltip>
        <h1 style="display: none;">{{ update }}</h1>
    </div>
</template>
<script>
import axios from 'axios';
import {TooltipPlugin} from '@syncfusion/ej2-vue-popups';

Vue.use(TooltipPlugin);
export default {
    name: 'processes-team',
    props: {
        process_id: {default: '',},
        data: {default: [],},
        dataItem: {},
        update: {default: -1,},
        style_justify_content: {default: '',},
    },
    data() {
        return {
            styleJustifyContent: this.style_justify_content,
            processesTeamData: []
        }
    },
    methods: {
        initProcessesTeam: function () {
            this.processesTeamData = this.data;
            if (!!this.process_id) {
                axios.post('/auth/processes/getProcessesTeam', {
                    processId: this.process_id,
                }).then(response => {
                    this.processesTeamData = response.data;
                    this.$emit('responsable_event', this.processesTeamData);
                });
            }
        },
    },
    mounted: function () {
        this.initProcessesTeam();
        this.$eventHub.$on('onGetTeamProcess', this.initProcessesTeam);
    },
    updated: function () {
        if (this.update !== -1) {
            this.initProcessesTeam();
        }
    }
}
</script>
